/**
 * Created by Akihiro-Kato on 2016/06/08.
 */
import React, { Component } from "react";
import {browserHistory, Router, Route, IndexRoute, Link} from 'react-router';
import GoogleMap from 'google-map-react';
import Marker from '../settings/_marker';

import data from '../data';


export default class footer extends Component {

  static defaultProps = {
    center: {lat: 35.635757, lng: 136.614116},
    zoom: 18,
    greatPlaceCoords: {lat: 35.635757, lng: 136.614116}
  }

	constructor(props) {
		super(props);
		this.state = {
    }
	}
	render() {
		return (
				<footer className="footer">
          <div id="map">
            <GoogleMap
              bootstrapURLKeys={{
                key: 'AIzaSyA65j590RZi8dE2x7glF0-ZYr0GlGDQ4S0',
                language: 'ja'
              }}
              defaultCenter={this.props.center}
              defaultZoom={this.props.zoom}
              options={{
                scrollwheel: false,
                styles: [{ stylers: [{ 'saturation': 2 }, { 'gamma': 1.42 }, { 'lightness': 3 }, { 'hue': '#a1ff00' }, { 'visibility': 'simplified' }] }]
              }}
            >
              <Marker lat={35.635757} lng={136.614116} />
            </GoogleMap>
          </div>
          <div className="upper">
            <div className="columnL">
              <div className="logo"><img src="/images/logo.png" alt="Gifu Indie Design Sessions"/></div>
              <table>
                <tbody>
                <tr>
                  <th>住所</th>
                  <td>〒501-1522<br />岐阜県本巣市根尾樽見33番地1</td>
                </tr>
                <tr>
                  <th>TEL</th>
                  <td><a href="tel:0581383055">0581-38-3055</a></td>
                </tr>
                <tr>
                  <th>EMAIL</th>
                  <td><a href="mailto:gids.neo@gmail.com">gids.neo@gmail.com</a></td>
                </tr>
                </tbody>
              </table>
              <p className="director">企画運営　<a href="http://r.yodaka.org/">一般社団法人よだか総合研究所</a></p>
            </div>
            <div className="columnR">
              <ul>
                <li key={data.menu.home.link}>
                  <Link to={data.menu.home.link}>{data.menu.home.name}</Link>
                </li>
                <li key={data.menu.member.link}>
                  <Link to={data.menu.member.link}>{data.menu.member.name}</Link>
                </li>
                <li key={data.menu.project.link}>
                  <Link to={data.menu.project.link}>{data.menu.project.name}</Link>
                </li>
                <li key={data.menu.opinion.link}>
                  <Link to={data.menu.opinion.link}>{data.menu.opinion.name}</Link>
                </li>
                <li key={data.menu.about.link}>
                  <Link to={data.menu.about.link}>{data.menu.about.name}</Link>
                </li>
                <li key={data.menu.guide.link}>
                  <Link to={data.menu.guide.link}>{data.menu.guide.name}</Link>
                </li>
              </ul>
            </div>
          </div>
					<div className="lower">
						<p>&copy; Gifu Indie Design Sessions. All Rights Reserved.</p>
					</div>
				</footer>
		)
	}
}





// WEBPACK FOOTER //
// ./src/js/components/_footer.js